query StreamingUsage {
  streamingUsage {
    connected
    storage {
      usedMinutes
      limitMinutes
      videoCount
      usedBytes
    }
    viewedMinutes
    periodStart
    periodEnd
    subscription {
      planName
      price
      currency
      frequency
    }
    cost {
      subscription
      delivery
      storage
      total
    }
    billingScopeMissing
    analyticsScopeMissing
    alerts {
      kind
      severity
      value
      threshold
    }
  }
}
